const routes = {
  path: 'complexidade',
  name: 'Complexidade',
  component: () => import('./Complexidade.vue'),
  children: [
    {
      path: 'inserir',
      name: 'Complexidade_Inserir',
      component: () => import('./ComplexidadeForm.vue'),
      meta: {
        rules: ['SOL-001'],
      }
    },
    {
      path: ':id/atualizar',
      name: 'Complexidade_Atualizar',
      component: () => import('./ComplexidadeForm.vue'),
      meta: {
        rules: ['SOL-001'],
      }
    },
  ],
  meta: {
    rules: ['SOL-001'],
  }
}

export default routes;